// extracted by mini-css-extract-plugin
export default {"licence-upload-form":"styles__licence-upload-form___yZxTI"};